var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1002 19.5612C16.1002 20.672 16.5357 21.7373 17.3108 22.5227C18.086 23.3082 19.1373 23.7494 20.2336 23.7494C21.3298 23.7494 22.3811 23.3082 23.1563 22.5227C23.9314 21.7373 24.3669 20.672 24.3669 19.5612C24.3669 18.4505 23.9314 17.3852 23.1563 16.5997C22.3811 15.8143 21.3298 15.373 20.2336 15.373C19.1373 15.373 18.086 15.8143 17.3108 16.5997C16.5357 17.3852 16.1002 18.4505 16.1002 19.5612Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.478 23.0516V29.3339L20.2336 27.2398L22.9891 29.3339V23.0516",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3446 25.1453H6.45575C5.72493 25.1453 5.02405 24.8511 4.50728 24.3275C3.99051 23.8039 3.7002 23.0937 3.7002 22.3532V8.39253C3.7002 6.85686 4.9402 5.6004 6.45575 5.6004H25.7446C26.4755 5.6004 27.1763 5.89457 27.6931 6.4182C28.2099 6.94182 28.5002 7.65201 28.5002 8.39253V22.3532C28.4997 22.8428 28.3721 23.3237 28.1303 23.7476C27.8885 24.1715 27.5409 24.5235 27.1224 24.7684M7.83353 11.1847H24.3669M7.83353 15.3728H11.9669M7.83353 19.561H10.5891",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificate_icon.b16135136877078d612071e6da3ba75f.svg";
export { ForwardRef as ReactComponent };